import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { customer_id } from '../utils/DictionaryManagementUtils';
//= ========================================================================
const Sim_B07_SendMoneyToCustomerIDManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={customer_id}
  />
);

export default Sim_B07_SendMoneyToCustomerIDManually;
